import moment from "moment";
import {
  Container,
  TitleBar,
  Title,
  SubTitle,
  ContentContainer
} from "./styled";

type Props = {
  title: string;
  subTitle: string;
  children?: React.ReactNode;
  selectedMonth?: string;
  handleCurrentMonth?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const StatusBox = <P extends Props>({
  title,
  subTitle,
  children,
  selectedMonth,
  handleCurrentMonth
}: P) => {
  const maxMonth = moment().format("YYYY-MM");

  return (
    <Container data-testid="status-box">
      <TitleBar>
        <Title data-testid="title">
          <span>{title}</span>
          {title === "월간 근무 현황" && (
            <input
              type="month"
              value={selectedMonth}
              max={maxMonth}
              onChange={handleCurrentMonth}
            />
          )}
        </Title>
        <SubTitle data-testid="sub-title">{subTitle}</SubTitle>
      </TitleBar>
      <ContentContainer>{children}</ContentContainer>
    </Container>
  );
};

export default StatusBox;
